var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "26px",
    viewBox: "0 0 32 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-2-copy-7",
    transform: "translate(-44.000000, -61.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B.",
    transform: "translate(44.448000, 61.800000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AG",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#282642"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "AG")), /*#__PURE__*/React.createElement("path", {
    d: "M30.42,25.2 C30.684,25.2 30.9,25.11 31.068,24.93 C31.236,24.75 31.32,24.54 31.32,24.3 L31.32,24.3 L31.32,19.548 C31.32,19.284 31.236,19.062 31.068,18.882 C30.9,18.702 30.684,18.612 30.42,18.612 L30.42,18.612 L25.668,18.612 C25.404,18.612 25.182,18.702 25.002,18.882 C24.822,19.062 24.732,19.284 24.732,19.548 L24.732,19.548 L24.732,24.3 C24.732,24.564 24.822,24.78 25.002,24.948 C25.182,25.116 25.404,25.2 25.668,25.2 L25.668,25.2 L30.42,25.2 Z",
    id: ".",
    fill: "#FF4C60"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f922ac56f5b8c1122e9aaa4623933e9.svg";
export { ForwardRef as ReactComponent };